import {eventTargetOrClosest} from '../utilities/helpers';

export default () => {
    const domElements = {
        nav: document.querySelector('.mobile-nav'),
        hamburger: document.querySelector('.hamburger'),
        body: document.body
    };

    const toggleSubMenu = (e) => {
        const item = eventTargetOrClosest(e, 'mobile-nav-list__item');

        if(!item) {
            return;
        }

        if(!item.classList.contains('menu-item-has-children')) {
            return;
        }

        e.preventDefault();
        item.classList.add('mobile-nav-list__item--active');

    }

    const toggleSlideSubMenu = (e) => {
        const icon = eventTargetOrClosest(e, 'mobile-nav-header__exit');
        const item = icon?.closest('.mobile-nav-list__item--active');
        item?.classList.remove('mobile-nav-list__item--active');
    }

    const closeAllSubMenus = () => {
        const activeItems = document.querySelectorAll('.mobile-nav-list__item--active');

        activeItems?.forEach(item => item.classList.remove('mobile-nav-list__item--active'));
    }

    const exitNavigation = (e) => {
        const icon = eventTargetOrClosest(e, 'mobile-nav-header__close');

        if(!icon) {
            return;
        }

        domElements.nav.classList.remove('mobile-nav--active');
        domElements.body.classList.remove('mobile-nav-opened');
        closeAllSubMenus()
    }

    const navigationHandler = (e) => {
        toggleSubMenu(e);
        toggleSlideSubMenu(e);
        exitNavigation(e);
    }

    domElements.nav?.addEventListener('click', navigationHandler);
    domElements.hamburger?.addEventListener('click', (e) => {
        e.preventDefault();
        domElements.nav.classList.toggle('mobile-nav--active');
        domElements.body.classList.toggle('mobile-nav-opened');
    });
}
